import React, { useState } from 'react'

//styles
import "./CreateProduct.css"

//components
import CreateNewProduct from '../../components/forms/CreateNewProduct/CreateNewProduct'
import ProductCard from '../../components/productCard/ProductCard';

const CreateProduct = () => {
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    

  return (
    <div className='CreateProduct-component'>
        <div className='CreateProduct-form'>
            <CreateNewProduct setPreviewUrl={setPreviewUrl} />
        </div>

        {/* <div className='CreateProduct-preview'>
            {previewUrl && <ProductCard 
                bcvPrice={12} 
                category={"Pin"}
                description={"product.description"}
                image={previewUrl}
                name={"Producto de prueba"} 
                franchise={"Pokemon"}/>}
        </div> */}
    </div>
  )
}

export default CreateProduct